var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraffitiBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 46,
    viewBox: "0 0 39 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.870361,
    y: 0.409912,
    width: 37.7871,
    height: 44.7918,
    rx: 10,
    fill: "#5387FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.76392,
    y: 8.58154,
    width: 24,
    height: 28.4489,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_300_20920",
    transform: "translate(-0.0926859) scale(0.0493905 0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_300_20920",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYEAQAAAAa7ikwAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAGAAAABgAPBrQs8AAAAHdElNRQfmDAIJJwsh9ifXAAABBklEQVRIx+2VvY6CQBRGv9lYQmJCqxWJD6HUvoKWPAKdBQ9kSY9WvIsFjSQ0NIRjMVFjdhdmWUpOMs39++7cycxIDkAYQl3zoq4hDF1yv1yCpPVa8n3pfLbL961tmIWbwJPN5m/xjkAQQJbB/W5XlkEQTDii5VIqClFVoqqkorC2KbrvPA/Kkm+UJZ3nTTCeOLYFd7u3bbu1tjgeyu89ZLrVSkoSqWmkKIIoenubRkoSuFyMud1Gdp+mDJKmo3cgLayf/V6CT58xMnn+ihkn8KyV56NG4CzQu4MpBMz1asynABjjkup40cYzC8wCs4Dzn3w6wQ9PxX+B4xHa9venum3hcOir8QBZxdKwOgsMrgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMi0xMi0wMlQwOTozOToxMSswMDowMDwA+68AAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjItMTItMDJUMDk6Mzk6MTErMDA6MDBNXUMTAAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAyMDIyLTEyLTAyVDA5OjM5OjExKzAwOjAwGkhizAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraffitiBlue);
export default __webpack_public_path__ + "static/media/graffiti-blue.1cb4388ccb28106920a1b41720e9da11.svg";
export { ForwardRef as ReactComponent };